var _excluded = ["svgRef"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M200.3,11.4L200,11L39.5,175.8l-0.8,0.8h32.7V389h97V263.6h65.4V389h94.9V176.6h32.7L200.3,11.4z"
});

var SvgHhg = function SvgHhg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHhg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hhg.03c25e51.svg";
export { ForwardRef as ReactComponent };